import jwtDecode from 'jwt-decode';
import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../../defaults';
import DirectorReport from './directorsReport';
import StudentsReport from './studentsReport';
import TeacherReport from './teachersReport';

const Reports = () => {
  const [role, setRole] = useState('');
  const { setLoading } = useContext(Context);

  useEffect(() => {
    setLoading(true);
    const persistedToken = jwtDecode(localStorage['token']);
    setRole(persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']);
    setLoading(false);
  }, []);

  return (
    <React.Fragment>
      {role && role === 'student' && <StudentsReport />}
      {role && role === 'teacher' && <TeacherReport />}
      {role && role === 'director' && <DirectorReport />}
    </React.Fragment>
  );
};

export default Reports;
